

import { useMemo } from 'react';
import { getLocale } from 'umi';

export default function useStepOptions(filterValue: any, disabled?: any) {
  const { stageList = [], defaultIconStage, } = filterValue || {};

  function capitalize(text: string) {
    const words = text?.split(" ");
    for (let i = 0;i < words?.length;i++) {
      words[i] = words?.[i]?.charAt(0)?.toUpperCase() + words?.[i]?.slice(1);
    }
    return words?.join(" ");
  }

  const stepOptions = useMemo(() => stageList?.map((item: any) => ({
    value: item?.stage_id || item?.code,
    text: getLocale() === 'zh-CN' ? (item?.stage_name_ch || item?.name_ch) : capitalize(item?.stage_name_en || item?.name_en),
    disabled: (disabled && item?.stage_id === disabled) || false,
    default: defaultIconStage?.includes(item?.stage_id)
  })), [stageList, defaultIconStage, getLocale()]);

  return stepOptions || [];
}